import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { NzFormatEmitEvent } from 'ng-zorro-antd/tree';
import { CommonService } from '../../service/common/common.service';

@Component({
  selector: 'organ',
  templateUrl: './organ.component.html',
  styleUrls: ['./organ.component.less'],
})
export class OrganComponent implements OnInit {
  @Input() data: Array<object> = []; // 组织架构数据
  @Input() organ_type: number = 3;
  @Input() showCreate: boolean = true; // 是否显示创建部门按钮
  @Input() createText: string = '创建部门'; // 创建按钮文字
  @Input() checkOrganId: any = 0;
  @Input() checkDepart: object = {}; // 选中的部门信息
  dropdownMenu: object = {
    1: {
      1: [
        { title: '创建部门', icon: 'icon_add', target: 'add', type: 4 },
        { title: '创建片区', icon: 'icon_add', target: 'add', type: 2 },
        // { title: '编辑', icon: 'icon_editor', target: 'editor', type: 1 },
      ],
      2: [
        { title: '创建部门', icon: 'icon_add', target: 'add', type: 4 },
        { title: '创建片区', icon: 'icon_add', target: 'add', type: 2 },
        { title: '编辑', icon: 'icon_editor', target: 'editor', type: 2 },
      ],
      3: [{ title: '创建部门', icon: 'icon_add', target: 'add', type: 4 }],
      4: [
        { title: '创建部门', icon: 'icon_add', target: 'add', type: 4 },
        { title: '编辑', icon: 'icon_editor', target: 'editor', type: 4 },
      ],
    },
    2: [
      { title: '创建部门', icon: 'icon_add', target: 'add' },
      { title: '编辑部门', icon: 'icon_editor', target: 'editor' },
    ],
    3: [
      { title: '创建部门', icon: 'icon_add', target: 'add' },
      { title: '编辑部门', icon: 'icon_editor', target: 'editor' },
    ],
    4: [
      { title: '创建部门', icon: 'icon_add', target: 'add' },
      { title: '编辑部门', icon: 'icon_editor', target: 'editor' },
    ],
  }; // 悬浮菜单
  selectIndex: string | number = -1;
  selectItem: object = {};
  unfoldID: Array<number> = [];
  searchKey = '';
  formatData: Array<object> = []; // 格式化的组织架构数据
  @Output() check = new EventEmitter(); // 点击部门或者小组事件
  @Output() createDepart = new EventEmitter(); // 点击创建部门事件
  @Output() cancel = new EventEmitter();
  @Output() operate = new EventEmitter();
  @Output() searchDuties = new EventEmitter();
  listOfData: any = []; // 显示的部门列表数据
  selectKey: Array<any> = [];
  expandedKeys: Array<any> = [];
  virtualHeight: any;

  constructor(private common: CommonService) {
    this.virtualHeight = document.body.clientHeight - 364 + 'px';
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] != undefined) {
      this.formatData = [...this.recursionStructure(this.data)];
      this.dealOrgan();
      if (this.data.length != 0) {
        this.defaultSelect();
      }
    }
  }

  nzEvent($event: NzFormatEmitEvent): any {
  }

  /**
   * 处理组织架构数据显示
   * @private
   */
  dealOrgan(): void {
    this.listOfData = [...this.formatData];
  }

  /**
   * 递归处理组织架构信息
   * @param data
   * @param level
   */
  recursionStructure(data: Array<object>): any {
    const response: Array<object> = [];
    for (const structure of data) {
      const item = {};
      item['title'] = structure['organ_name'];
      item['key'] = structure['organ_id'];
      item['value'] = structure['organ_id'];
      item['parent'] = structure['organ_pid'];
      item['status'] = structure['status'];
      item['type'] = structure['organ_type_extra'];
      item['organ_type'] = structure['organ_type'];
      item['path_ids'] = structure['path_ids'];
      Object.assign(item, structure);
      item['organ_peoples'] = structure['organ_peoples'];
      // 判断当前组织的状态是否是冻结状态
      if (structure['status'] == 3) {
        item['selectable'] = false;
      }
      if (structure['child_node'].length > 0) {
        item['children'] = this.recursionStructure(structure['child_node']);
      } else {
        item['isLeaf'] = true;
      }
      if (structure['isCompany']) {
        item['selectable'] = false;
      }
      response.push(item);
    }
    return response;
  }

  /**
   * 点击组织架构
   * @param event
   */
  nzClick(event: NzFormatEmitEvent): void {
    this.selectKey = [event.node.origin.key];
    this.check.emit({ event: 'check', target: event.node.origin });
  }

  /**
   * 操作
   * @param menu
   * @param node
   */
  operation(menu: any, node: any): void {
    if (menu.target == 'freeze' && node.origin['organ_peoples'] != 0 && node.origin['status'] != 3) {
      this.common.msg.error('当前部门/片区/门店员工不为0，无法冻结');
      return;
    }
    this.operate.emit({ event: menu.target, target: node.origin, type: menu.type });
  }

  /***
   * 点击创建部门
   */
  createDepartFun(): void {
    this.createDepart.emit({ event: 'add' });
  }

  /**
   * 选择默认
   */
  defaultSelect(): void {
    this.selectKey = this.checkDepart['organ_id'] == undefined ? [this.data[0]['organ_id']] : [this.checkDepart['organ_id']];

    const expandedKeys = [];
    if (this.checkDepart['path_ids'] != undefined) {
      this.checkDepart['path_ids'].split(',').forEach(item => {
        expandedKeys.push(parseInt(item));
      });
    } else {
      expandedKeys.push(parseInt(this.data[0]['organ_id']));
    }

    this.expandedKeys = [...expandedKeys];
    this.check.emit({ event: 'check', target: this.checkDepart });
  }

  /**
   * 左侧组织架构筛选事件
   * @param $event
   */
  searchChange($event: any): void {
    this.searchDuties.emit({ event: 'search', target: { details: this.searchKey } });
  }

  /**
   * 取消检索
   */
  cancelSearch(): void {
    this.searchKey = '';
    this.searchDuties.emit({ event: 'search', target: { details: this.searchKey } });
  }
}
